import properties from '../modules/ajio-util/properties';
import { getParams, isServerRendering } from './pageInfo';
import { readCookie } from '../components/common/Cookie';
import getFingerPrint from './getFingerPrint.js';

let dataGrinch = {};

if (typeof DataGrinch !== 'undefined') {
  dataGrinch = new DataGrinch();
}

function DataGrinchClient() {
  function init(params) {
    const { browserId } = params;
    return new Promise((resolve, reject) => {
      getKey(browserId)
        .then(({ browserId, msg }) => {
          if (!isServerRendering() && !sessionStorage.getItem('sessionId')) {
            setSessionId(browserId);
          }
          // console.log(msg ? msg : `Successfully created finger print with ${browserId}`);
          resolve(browserId);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  function setSessionId(browserId) {
    const today = new Date();
    const sessionId = `${browserId}-${today.getFullYear()}${today.getMonth() +
      1}${today.getDate()}-${Math.floor((crypto.getRandomValues(new Uint32Array(1))[0] / (0xFFFFFFFF + 1)) * 100000 + 1)}`;
    !isServerRendering() && sessionStorage.setItem('sessionId', sessionId);
    return sessionId;
  }
  function getKey(browserId) {
    return new Promise(async (resolve, reject) => {
      if (!isServerRendering() && localStorage.getItem('browserId')) {
        resolve({
          browserId: localStorage.getItem('browserId'),
          msg: `Successfully retrieve fingerprint`
        });
      }
      if (browserId) {
        resolve({ browserId, msg: `Successfully retrieve fingerprint` });
      } else {
        const Fingerprint2 = await getFingerPrint();
        const id = Fingerprint2.nanoid();
        !isServerRendering() && localStorage.setItem('browserId', id);
        resolve({ browserId: id, msg: `Successfully created finger print with ${id}` });
      }
    });
  }

  function generateEvent({ Event = 'CLICKSTREAM_EVENT', value = {} }) {
    const eventObj = {};
    const { PageType = '', PageId = '' } = getParams(location);
    for (const key in value) {
      eventObj[key] = value[key];
    }
    eventObj.Event = Event;
    if (PageType) {
      eventObj.PageType = PageType;
    }

    if (PageId) {
      eventObj.PageId = PageId;
    }
    sendEvent(Event, eventObj);
  }

  function sendEvent(type = 'Event', eventObj = {}) {
    eventObj.Timestamp = Date.now();
    if (!isServerRendering() && !eventObj.BrowserId && localStorage.getItem('browserId')) {
      eventObj.BrowserId = localStorage.getItem('browserId');
    }

    const cookie = !isServerRendering() && readCookie('nq');
    if (cookie) {
      const cookieList = cookie.split(':');
      if (cookieList.length) {
        let primarykeyString = '';
        primarykeyString = cookieList.reduce((accumlator, item) => {
          if (item.startsWith('pk')) {
            accumlator = item;
          }
          return accumlator;
        }, '');
        if (primarykeyString) {
          eventObj.UserId = primarykeyString.split('=')[1];
        }
      }
    }

    if (!isServerRendering() && sessionStorage.getItem('sessionId')) {
      eventObj.SessionId = sessionStorage.getItem('sessionId');
    } else {
      setSessionId(eventObj.BrowserId);
      eventObj.SessionId = (!isServerRendering() && sessionStorage.getItem('sessionId')) || '';
    }
    // console.log(eventObj);
    const appKey = properties.getProperty('dataGrinchAppKey');
    if (type != 'PAGE_VISIT') {
      return new Promise((resolve, reject) => {
        !isServerRendering() &&
          Object.keys(dataGrinch).length &&
          dataGrinch.writeLog(appKey, type, eventObj, (error, data) => {
            if (error) {
              // console.log(`Something to went wrong to send event ${error}`);
            } else {
              // console.log(`Successfully sent event ${JSON.stringify(eventObj)}`);
            }
          });
      });
    }
  }

  return {
    init,
    sendEvent,
    generateEvent
  };
}

const { init, sendEvent, generateEvent } = DataGrinchClient();
export { init, sendEvent, generateEvent };
